module.exports = __webpack_public_path__ + "img/overviewIcon.5b1b6251.png";